<template>
  <div class="select-wrap" v-if="selectShow">
    <div class="select-con">
      <div class="select-header">
        <img :src="require('../assets/images/topBorder.png').default" alt="" />
      </div>
      <div class="select-body">
        <h6>机构选择</h6>
        <el-input
          class="select-input"
          placeholder="-关键词搜索-"
          suffix-icon="el-icon-search"
          v-model="keyword"
          @input="handleKeywordInput"
        />
        <div class="select-xlk">
          <p>筛选条件：</p>
          <div>
            <el-select
              class="xlk"
              v-model="province"
              placeholder="-请选择省份-"
              @change="handleProvinceSelect"
            >
              <el-option
                v-for="item in provinceData"
                :key="item.orgId || item.province"
                :label="item.province"
                :value="item.province"
              />
            </el-select>
            <el-select
              class="xlk"
              v-model="city"
              placeholder="-请选择城市-"
              @change="handleCitySelect"
            >
              <el-option
                v-for="item in cityData"
                :key="item.orgId || item.city"
                :label="item.city"
                :value="item.city"
              />
            </el-select>
            <el-select
              class="xlk"
              v-model="organization"
              placeholder="-请选择机构-"
              @change="handleOrganizationSelect"
            >
              <el-option
                v-for="item in organizationData"
                :key="item.orgId || item.orgName"
                :label="item.orgName"
                :value="item.orgName"
              />
            </el-select>
          </div>
        </div>
        <div class="result">
          <p
            v-for="item in resultData"
            :key="item.orgId || item.orgName"
            @click="handleSkip(item)"
          >
            {{ item.orgName }}
          </p>
        </div>
      </div>
      <div class="select-footer">
        <img :src="require('../assets/images/bottomBorder.png').default" alt="" />
        <p v-if="organization" @click="handleSkip(selectOrganization)">进入</p>
      </div>
      <div class="close" @click="handleClose">
        <img :src="require('../assets/images/turn_off.png').default" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http/index'

export default {
  props: {
    selectShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      resultData: [],
      keyword: '',
      original: [],
      province: '',
      provinceData: [],
      city: '',
      cityData: [],
      organization: '',
      organizationData: [],
      selectOrganization: {}
    }
  },
  created () {
    this.fetchOrgList()
  },
  methods: {
    async fetchOrgList () {
      try {
        const res = await http.getOrglist()
        let data = res?.data?.data
        // 确保 data 是数组
        if (!Array.isArray(data)) {
          data = []
        }
        this.original = data
        this.resultData = [...data]
        this.provinceData = this.unique(data, 'province')
      } catch (error) {
        this.original = []
        this.resultData = []
        this.provinceData = []
      }
    },

    handleClose () {
      this.$emit('handleClose', false)
    },

    handleSkip (data) {
      if (!data?.url) {
        console.warn('Attempted to skip with invalid org data:', data)
        return
      }
      const BASE_API_TESTS = process.env.VUE_APP_BASE_API_TESTS
      window.open(BASE_API_TESTS + `#/index?abbr=${encodeURIComponent(data.url)}`, '_blank')
    },

    handleKeywordInput () {
      if (!Array.isArray(this.original)) return
      const kw = this.keyword.trim()
      if (!kw) {
        this.resultData = [...this.original]
        return
      }
      this.resultData = this.original.filter(item =>
        item?.orgName?.includes(kw)
      )
    },

    handleProvinceSelect () {
      this.city = ''
      this.organization = ''
      this.cityData = []
      this.organizationData = []

      if (!Array.isArray(this.original)) return

      const filtered = this.original.filter(item =>
        item?.province === this.province
      )
      this.cityData = this.unique(filtered, 'city')
    },

    handleCitySelect () {
      this.organization = ''
      this.organizationData = []

      if (!Array.isArray(this.original)) return

      const filtered = this.original.filter(item =>
        item?.province === this.province && item?.city === this.city
      )
      this.organizationData = this.unique(filtered, 'orgName')
    },

    handleOrganizationSelect () {
      if (!Array.isArray(this.organizationData)) return

      const selected = this.organizationData.find(
        item => item.orgName === this.organization
      )
      this.selectOrganization = selected || {}
    },

    // 去重工具函数：根据指定字段去重
    unique (arr, keyField) {
      if (!Array.isArray(arr)) return []
      const seen = new Set()
      return arr.filter(item => {
        if (!item || typeof item !== 'object') return false
        const val = item[keyField]
        if (val == null) return false // 排除 null/undefined
        const uniqueKey = `${typeof val}-${val}`
        if (seen.has(uniqueKey)) return false
        seen.add(uniqueKey)
        return true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/sass/variable.scss';

.select-wrap {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  overflow-y: auto;

  .select-con {
    width: 533px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 15px;

    .select-header {
      position: absolute;
      top: -90px;
      img {
        width: 533px;
        height: 240px;
      }
    }

    .select-body {
      width: 470px;
      margin: 148px auto 60px;

      h6 {
        color: $el-main-color;
        padding-bottom: 5px;
        border-bottom: 1px dashed #333;
      }

      .select-input {
        width: 60%;
        margin: 20px 0;
      }

      .select-xlk {
        p {
          margin-bottom: 10px;
        }

        div {
          display: flex;
          justify-content: space-between;

          .xlk {
            width: 30%;
          }
        }
      }

      .result {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;

        p {
          padding: 3px 10px;
          border: 1px solid #ff8b00;
          color: #ff8b00;
          font-size: 12px;
          border-radius: 3px;
          margin: 5px 15px 5px 0;
          cursor: pointer;

          &:hover {
            color: #fff;
            background: #ff8b00;
          }
        }
      }
    }

    .select-footer {
      position: absolute;
      bottom: -4px;

      img {
        width: 533px;
        height: 43px;
      }

      p {
        position: absolute;
        bottom: 30%;
        left: 46%;
        color: #fff;
        cursor: pointer;
        transform: scale(1);
        animation: changeBiger 1s infinite ease-in-out alternate;
      }
    }

    .close {
      position: absolute;
      bottom: -98px;
      left: 50%;
      margin-left: -23px;
      cursor: pointer;

      img {
        width: 46px;
        height: 94px;
      }
    }
  }
}

@keyframes changeBiger {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.5);
  }
}
</style>
